export const getUrlPart = (index) => {
   const queryParams = new URLSearchParams(window.location.search);
   return queryParams.get(index);
};